import {Dashboards_Inst_Cnd } from '../models/domain/dashboards_inst_cnd';
import { ObjectWrapper } from '../wrappers/object.wrapper';
import { ObjectWrapperUtil } from './object.wrapper.util';
import { Util } from './util';

export class Dashboards_Inst_CndsUtil {
    private static instance: Dashboards_Inst_CndsUtil;

    static getInstance(): Dashboards_Inst_CndsUtil {
        if (!Dashboards_Inst_CndsUtil.instance) {
            Dashboards_Inst_CndsUtil.instance = new Dashboards_Inst_CndsUtil();
        }
        return Dashboards_Inst_CndsUtil.instance;
    }

    /**
     * Splt_Inst_CndsUtil is a singleton class, so use Splt_Inst_CndsUtil.getInstance() method instead of creating new Splt_Inst_CndsUtil().
     */
    private constructor() {

    }

    getNewDashboards_Inst_Cnd(objectWrapper: ObjectWrapper, index: number): Dashboards_Inst_Cnd {
        let dashboards_Inst_Cnd: Dashboards_Inst_Cnd = new Dashboards_Inst_Cnd();

        dashboards_Inst_Cnd.dashboards_Inst_Cnd_Id = ObjectWrapperUtil.getInstance().getNewSub_Id(objectWrapper);
        dashboards_Inst_Cnd.dashboardsCndNm = Util.getInstance().getNewName('CND_NAME_1', objectWrapper.subNames);

        dashboards_Inst_Cnd.dashboards_Inst_Id = objectWrapper.obj_Id;
        dashboards_Inst_Cnd.dxMp_Id = objectWrapper.dxMp_Id;
        dashboards_Inst_Cnd.srt_Order = index;

        dashboards_Inst_Cnd.valid_Cd = "EMPT_COND";

        return dashboards_Inst_Cnd;
    }



    cloneSplt_Inst_Cnd(dashboards_Inst_Cnd: Dashboards_Inst_Cnd) {
        let clonedDashboards_Inst_CndTmp: Dashboards_Inst_Cnd = new Dashboards_Inst_Cnd();
        clonedDashboards_Inst_CndTmp.dashboards_Inst_Cnd_Id = dashboards_Inst_Cnd.dashboards_Inst_Cnd_Id;
        clonedDashboards_Inst_CndTmp.dashboards_Inst_Id = dashboards_Inst_Cnd.dashboards_Inst_Id;
        clonedDashboards_Inst_CndTmp.dxMp_Id = dashboards_Inst_Cnd.dxMp_Id;
        clonedDashboards_Inst_CndTmp.dashboardsCndNm = dashboards_Inst_Cnd.dashboardsCndNm;
        clonedDashboards_Inst_CndTmp.dashboardsCnd = dashboards_Inst_Cnd.dashboardsCnd;
        clonedDashboards_Inst_CndTmp.valid_Cd = dashboards_Inst_Cnd.valid_Cd;
        clonedDashboards_Inst_CndTmp.srt_Order = dashboards_Inst_Cnd.srt_Order;
        return clonedDashboards_Inst_CndTmp;
    }


    copy(dashboards_Inst_CndsTmp: Array<Dashboards_Inst_Cnd>): Array<Dashboards_Inst_Cnd> {
        let dashboards_Inst_Cnds: Array<Dashboards_Inst_Cnd> = new Array<Dashboards_Inst_Cnd>();

        for (let i: number = 0; i < dashboards_Inst_CndsTmp.length; i++) {
            let dashboards_Inst_Cnd: Dashboards_Inst_Cnd = dashboards_Inst_CndsTmp[i] as Dashboards_Inst_Cnd;
            dashboards_Inst_Cnds.push(dashboards_Inst_Cnd.copy())
        }

        return dashboards_Inst_Cnds;
    }

    copyFrom(dashboards_Inst_Cnds: Array<Dashboards_Inst_Cnd>, dashboards_Inst_CndsTmp: Array<Dashboards_Inst_Cnd>): void {
        let dashboards_Inst_CndsMap: Map<number, Dashboards_Inst_Cnd> = new Map<number, Dashboards_Inst_Cnd>();

        for (let i: number = 0; i < dashboards_Inst_Cnds.length; i++) {
            let dashboards_Inst_Cnd: Dashboards_Inst_Cnd = dashboards_Inst_Cnds[i] as Dashboards_Inst_Cnd;
            dashboards_Inst_CndsMap.set(dashboards_Inst_Cnd.dashboards_Inst_Cnd_Id, dashboards_Inst_Cnd);
        }
        dashboards_Inst_Cnds.splice(0, dashboards_Inst_Cnds.length);

        for (let i: number = 0; i < dashboards_Inst_CndsTmp.length; i++) {
            let dashboards_Inst_CndTmp: Dashboards_Inst_Cnd = dashboards_Inst_CndsTmp[i] as Dashboards_Inst_Cnd;

            let dashboards_Inst_Cnd: Dashboards_Inst_Cnd = dashboards_Inst_CndsMap.get(dashboards_Inst_CndTmp.dashboards_Inst_Cnd_Id);
            if (dashboards_Inst_Cnd) {
                dashboards_Inst_Cnd.copyFrom(dashboards_Inst_CndTmp);
            } else {
            dashboards_Inst_Cnd =Dashboards_Inst_Cnd.parse(dashboards_Inst_CndTmp);
            }

            dashboards_Inst_Cnds.push(dashboards_Inst_Cnd);
        }
    }

    compare(dashboards_Inst_Cnds: Array<Dashboards_Inst_Cnd>, dashboards_Inst_CndsTmp: Array<Dashboards_Inst_Cnd>): string {
        let dashboards_Inst_CndsLength = dashboards_Inst_Cnds.length;
        let dashboards_Inst_CndsTmpLength = dashboards_Inst_CndsTmp.length;

        if (dashboards_Inst_CndsLength != dashboards_Inst_CndsTmpLength) {
            return 'Splt_Inst_Cnds length is different.';
        }

        for (let i: number = 0; i < dashboards_Inst_CndsLength; i++) {
            let dashboards_Inst_Cnd: Dashboards_Inst_Cnd = dashboards_Inst_Cnds[i] as Dashboards_Inst_Cnd;
            let dashboards_Inst_CndTmp: Dashboards_Inst_Cnd = dashboards_Inst_CndsTmp[i] as Dashboards_Inst_Cnd;
            if (dashboards_Inst_Cnd.compare(dashboards_Inst_CndTmp) != '') {
                return dashboards_Inst_Cnd.dashboards_Inst_Cnd_Id + ' is not equal.'
            }
        }

        return '';
    }

    toString(dashboards_Inst_Cnds: Array<Dashboards_Inst_Cnd>): string {
        let str: string = "Dashboards_Inst_Cnd Length: " +dashboards_Inst_Cnds.length;

        for (let i: number = 0; i < dashboards_Inst_Cnds.length; i++) {
            str += dashboards_Inst_Cnds[i].toString();
        }

        return str;
    }
}